mobileSize = 1079;

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1080) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1079) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // New 
  $.fn.placeChange = function(){
    if ($('#body').hasClass('saffireMobileSize')) {
      $('.header-top-right .viewcart').insertBefore('.saffireMobileSize .mobile-nav-toggle');
      $('.header a.strates-show-tix').insertBefore('.saffireMobileSize .viewcart');
    } else {
      $('.headerInnerContent .container .viewcart').insertAfter('.saffireLargeSize #weatherBugWidget');
      $('.header a.strates-show-tix').insertAfter('.saffireLargeSize .header-top-right');
    }
  }

});

$(window).load(function(){
  $.fn.placeChange();
	$('body').addClass('pageIsLoaded'); 
  $('.subscribe-container .emailSubmitButton').text('subscribe'); 
  $(".subscribe-container .emailInputField input").attr("value", "");
  $(".subscribe-container .emailInputField input").attr("placeholder", "Enter Email Address");
  
  
	$(".featureLineup-text").text(function(){
	  return $(this).text().length > 130 ? $(this).text().substr(0, 130)+'...' : $(this).text();
	});

  setInterval(function () {
    let str = $("#weatherBugDescription").text();
    let weatherBugSet = $("#weatherBugWidget").hasClass("weatherBugSet");
    if (weatherBugSet || str == "") return;
    $("#weatherBugWidget").addClass("weatherBugSet");
    let findSpace = str.lastIndexOf(" ");
    let stringLength = str.length;
    let res = str.substring(findSpace, stringLength);
    let start = str.substring(0, findSpace);
    $("#weatherBugDescription").html(
      '<span class="weatherDescriptive">' + start + "</span>" + res
    );
    $("#weatherBugWidget").css("visibility", "visible");
  }, 12);
});

$(window).resize(function() {
  $.fn.placeChange();
});
